import { render } from "./CompleteTestModal.vue?vue&type=template&id=ea9bb81c&scoped=true"
import script from "./CompleteTestModal.vue?vue&type=script&lang=js"
export * from "./CompleteTestModal.vue?vue&type=script&lang=js"

import "./CompleteTestModal.vue?vue&type=style&index=0&id=ea9bb81c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea9bb81c"]])

export default __exports__